import React, {  Component } from 'react';
import { inject, observer } from 'mobx-react';
import BlogStore from "stores/blog.store";
import { Bind } from 'lodash-decorators';
import root from "window-or-global";
import styles from './Pagination.module.scss';

export interface BlogListingProps {
	blogStore: BlogStore; // TODO typing
}

@inject('blogStore')
@observer
class Pagination extends Component<BlogListingProps> {

	@Bind
	onPageClick(pageNumber: number) {
		const {
			blogStore: {
				setPage,
			},
		} = this.props;
		setPage(pageNumber);
		root.scrollTo(0, 0);
	}

	render() {
		const {
			blogStore: {
				pagesCount,
				page,
			},
		} = this.props;

		if (pagesCount === 1) {
			return null;
		}

		return (
			<div className={styles.Container}>
				{
					Array.from({length: pagesCount}, (v, k) => k + 1)
						.map((pageNumber: number) => (
							/* TODO: verify styles after change */
							<span
								onClick={() => this.onPageClick(pageNumber)}
								className={`${styles.PageNumber} ${pageNumber === page ? styles.Active : ''}`}
							>
								{pageNumber}
							</span>
						))
				}
			</div>
		);
	}
}


export default Pagination as any;
// type X = Pagination extends Component<{
// 	blogStore?: BlogStore; // TODO typing
// }>;

// export default Pagination<T extends Pagination>;